import { useEffect, useState } from 'react';
import { useDevice } from '../context/DeviceContext';
import { readVirtualKeysSupport } from './ButtonPerformance';

const UNKNOWN = Object.freeze({ ready: false, supported: false });

/**
 * 导航用：4.0 按键性能机型，且 byte27 bit0-3 ≥ 3 时才露出「虚拟按键」和「行程校准」。
 * ready 表示已经读到 type3 的按键类型，避免未知时误跳转。
 */
export function useVirtualKeysSupport() {
  const { dataStore, activeAdapter, isConnected } = useDevice();
  const [state, setState] = useState(UNKNOWN);

  useEffect(() => {
    if (!isConnected || !dataStore) {
      setState(UNKNOWN);
      return undefined;
    }

    const sync = (performanceData) => {
      setState(readVirtualKeysSupport(performanceData));
    };

    const reset = () => setState(UNKNOWN);
    sync(dataStore.getData('performanceData'));
    dataStore.on('performanceData', sync);
    dataStore.on('clear', reset);
    return () => {
      dataStore.off('performanceData', sync);
      dataStore.off('clear', reset);
    };
  }, [dataStore, isConnected]);

  const capability = activeAdapter?.capabilities?.hitsSettings === true;
  return {
    ready: state.ready,
    supported: state.supported,
    visible: capability && state.supported,
  };
}
